




































import Vue from 'vue';
import { Component } from 'vue-property-decorator';
import { VFields } from '@/models/v-fields';
import { StoreModel, ReadEmailConfig } from '@/models/admin/store';
import { Base } from '@/components/common/base';
import { stripQuotes } from '@servicestack/client';
import { Utils } from '@/helper/utils';
import {storeService} from '@/shared';
import { ValidationRules } from '@/helper/enum';

@Component({
  props: ['methodName', 'progress'],
  computed: {
    methodtoCall: {
      get() {
        return this.$props.methodName;
      },
    },
  },
  components: {
    formlyTextLabel: () => import('@/components/common/formlyTextLabel.vue'),
  },
})
export default class ReadEmailPage extends Base {
  public storeViewModel: any = {};
  public storeModel: StoreModel = {};
  public stores: any[] = [];
  public emailType: any[] = ['Gmail', 'Microsoft', 'other'];
  public hostProtocolType: any[] = ['POP3', 'IMAP'];
  public readEmailConfigModel: ReadEmailConfig = {};
  public form: any = {};
  public readEmailConfigFields: Array<VFields<any>> = [];
  public storeId: string = '';
  public id: string = '';
  public tenantId: number = 0;
  public enterpriseId: number = 0;
  public requestProgress: boolean = false;
  public verifyConnectionrequestProgress: boolean = false;
  public passwordLink: string = '';

  public beforeDestroy() {
    const buttons = [];
    this.$emit('updateToolBar', buttons);
  }
  public callMethod(methodName): void {
    if (methodName === 'backToStoreEdit') {
      this.$router
        .push({
          name: 'admin.stores.edit',
          params: { id: this.storeId.toString(), tab: 'ReadEmailConfig' },
        })
        .catch((ex) => {
          console.log(ex);
        });
    } else if (methodName === 'backToStoreAdd') {
      this.$router
        .push({
          name: 'admin.stores.add',
          params: {
            tenantId: this.tenantId.toString(),
            enterpriseId: this.enterpriseId.toString(),
            tab: 'ReadEmailConfig',
          },
        })
        .catch((ex) => {
          console.log(ex);
        });
    }
    if (methodName === 'submit') {
      if (!this.form.$valid) {
        this.showAlert(false, this.$t('stores.readEmail.alertInvalidForm'));
        this.resetMethodName(methodName);
        return;
      }
      this.saveReadEmailConfig();
    }
    this.resetMethodName(methodName);
  }
  public resetMethodName(methodName): void {
    if (methodName !== '') {
      this.$emit('resetMethodName', methodName);
    }
  }
  public updateToolBar(): void {
    const buttons: any = [];
    if (this.storeId) {
      buttons.push({
        id: '0',
        type: 'button',
        title: this.$parent.$t('stores.btnBackToStoreTitle'),
        disabled: false,
        visible: true,
        class: 'btn',
        label: this.$parent.$t('stores.btnBack'),
        click: 'backToStoreEdit',
        icon: 'fas fa-arrow-left',
      });
    } else {
      buttons.push({
        id: '0',
        type: 'button',
        title: this.$parent.$t('stores.btnBackToStoreTitle'),
        disabled: false,
        visible: true,
        class: 'btn',
        label: this.$parent.$t('stores.btnBack'),
        click: 'backToStoreAdd',
        icon: 'fas fa-arrow-left',
      });
    }
    this.$emit('updateToolBar', buttons);
  }
  public mounted() {
    this.readEmailConfigModel.isEmailSyncEnabled = true;
    if (this.$route.params.storeId) {
      this.storeId = this.$route.params.storeId;
      this.getStoreInfo();
    }

    this.id = this.$route.params.id;
    // Toolbar
    this.updateToolBar();
    this.$watch('methodtoCall', (newVal, oldVal) => {
      if (newVal) {
        this.callMethod(newVal);
      }
    });
  }
  public setReadEmailFields(): void {
    this.readEmailConfigFields = [
      {
        key: 'storeName',
        required: false,
        type: 'v-alynk-text-field',
        templateOptions: {
          required: false,
          disabled: true,
          label: this.$t(
            'stores.readEmail.readEmailFields.selectStore'
          ) as string,
          loading: false,
          rules:[
            v => this.required('Store Name',v)
          ]
        },
      },
      {
        key: 'emailType',
        required: true,
        type: 'v-alynk-select',
        templateOptions: {
          required: true,
          disabled: false,
          label: this.$t(
            'stores.readEmail.readEmailFields.selectEmailType'
          ) as string,
          value: 'id',
          items: this.emailType,
          altag: 'Select Email Types',
          loading: false,
          events: {
            onChange: (items, value) => {
              this.updateEmailType(value);
            },
          },
          rules:[
            v => this.required('Email Type',v)
          ]
        },
      },
      {
        key: 'hostProtocol',
        required: true,
        type: 'v-alynk-select',
        templateOptions: {
          disabled: false,
          required: true,
          label: this.$t(
            'stores.readEmail.readEmailFields.hostProtocol'
          ) as string,
          items: this.hostProtocolType,
          counter: 50,
          loading: false,
          events: {
            onChange: (items, value) => {
              this.updateHostProtocolType(value);
            },
          },
          rules:[
            v => this.required('Host Protocol',v)
          ]
        },
      },
      {
        key: 'host',
        required: true,
        type: 'v-alynk-text-field',
        templateOptions: {
          disabled: false,
          required: true,
          label: this.$t('stores.readEmail.readEmailFields.host') as string,
          counter: 50,
          loading: false,
          rules:[
            v => this.required('Host',v)
          ]
        },
      },
      {
        key: 'port',
        required: true,
        type: 'v-alynk-text-field',
        templateOptions: {
          disabled: false,
          required: true,
          label: this.$t('stores.readEmail.readEmailFields.port') as string,
          counter: 50,
          loading: false,
          rules:[
            v => this.required('Port',v)
          ]
        },
      },
      {
        key: 'userName',
        required: true,
        type: 'v-alynk-text-field',
        validators: {
          email: (field, model, next) => {
            next(Utils.EmailRegex.test(model[field.key]));
          },
        },
        templateOptions: {
          disabled: false,
          type: 'email',
          label: this.$t('stores.readEmail.readEmailFields.userName') as string,
          counter: 50,
          loading: false,
          rules:[
            v => this.required('User Name',v),
          ]
        },
      },
      {
        key: 'password',
        required: true,
        type: 'v-alynk-text-field',
        templateOptions: {
          disabled: false,
          type: 'password',
          label: this.$t('stores.readEmail.readEmailFields.password') as string,
          counter: 50,
          loading: false,
          jobtitle: 'test',
          rules:[
            v => this.required('Password',v)
          ]
        },
      },
      {
        key: 'label',
        type: 'v-alynk-label',
        templateOptions: {
          disabled: true,
          display: true,
          label: this.$t('stores.readEmail.appPasswordHint') as string,
          propertyValue: this.passwordLink as string,
          name: 'AnchorTag',
        },
      },
      {
        key: 'ssl',
        required: false,
        type: 'v-alynk-switch',
        templateOptions: {
          disabled: false,
          required: false,
          label: this.$t('stores.readEmail.readEmailFields.ssl') as string,
          counter: 50,
          loading: false,
        },
      },
      {
        key: 'isEmailSyncEnabled',
        required: false,
        type: 'v-alynk-switch',
        templateOptions: {
          disabled: false,
          required: false,
          label: this.$t('stores.readEmail.readEmailFields.email') as string,
          counter: 50,
          loading: false,
        },
      },
    ];
  }

  public async getStoreInfo(): Promise<void> {
    try {
      const response = await storeService.getStore(Number(this.storeId));
      this.storeViewModel = response;
      if (this.storeViewModel.storeJson.readEmailConfig.length > 0) {
        if (
          this.storeViewModel.storeJson.readEmailConfig[0].emailType == 'Gmail'
        ) {
          this.passwordLink =
            'https://support.google.com/accounts/answer/185833?hl=en';
        } else if (
          this.storeViewModel.storeJson.readEmailConfig[0].emailType ==
          'Microsoft'
        ) {
          this.passwordLink =
            'https://support.microsoft.com/en-us/account-billing/using-app-passwords-with-apps-that-don-t-support-two-step-verification-5896ed9b-4263-e681-128a-a6f2979a7944';
        } else if (
          this.storeViewModel.storeJson.readEmailConfig[0].emailType == 'other'
        ) {
          this.passwordLink = '';
        }
      } else {
        this.passwordLink = '';
      }
      this.setReadEmailFields();
      this.formlyShowSkeleton(this.readEmailConfigFields);
      this.storeModel.id = this.storeViewModel.id;
      this.storeModel.storeJson = this.storeViewModel.storeJson;
      this.readEmailConfigModel.storeName = this.storeViewModel.storeJson.name;
      this.readEmailConfigModel.storeId = this.storeViewModel.id;
      if (this.storeViewModel.storeJson.readEmailConfig.length > 0) {
        if (this.storeViewModel.storeJson.readEmailConfig[0].id) {
          this.readEmailConfigModel = {
            id: this.storeViewModel.storeJson.readEmailConfig[0].id,
            storeId: this.storeModel.id,
            storeName: this.storeViewModel.storeJson.name,
            host: this.storeViewModel.storeJson.readEmailConfig[0].host,
            port: this.storeViewModel.storeJson.readEmailConfig[0].port,
            ssl: this.storeViewModel.storeJson.readEmailConfig[0].ssl,
            userName: this.storeViewModel.storeJson.readEmailConfig[0].userName,
            password: this.storeViewModel.storeJson.readEmailConfig[0].password,
            hostProtocol: this.storeViewModel.storeJson.readEmailConfig[0]
              .hostProtocol,
            emailType: this.storeViewModel.storeJson.readEmailConfig[0]
              .emailType,
            isEmailSyncEnabled: this.storeViewModel.storeJson.readEmailConfig[0]
              .isEmailSyncEnabled,
          };
        }
      }
      this.formlyShowSkeleton(this.readEmailConfigFields);
    } finally {
      this.formlyHideSkeleton(this.readEmailConfigFields);
    }
  }

  public validateReadEmailConfig(): Vue & { validate: () => boolean } {
    return this.$refs.readEmailConfigForm as Vue & { validate: () => boolean };
  }

  public async saveReadEmailConfig(): Promise<void> {
    if(this.validateReadEmailConfig().validate()){
      try {
        this.requestProgress = true;
        this.$emit('update:progress', this.requestProgress);
        if (
          this.readEmailConfigModel &&
          this.readEmailConfigModel.storeId &&
          this.readEmailConfigModel.storeName &&
          this.readEmailConfigModel.emailType &&
          this.readEmailConfigModel.hostProtocol &&
          this.readEmailConfigModel.host &&
          this.readEmailConfigModel.port &&
          this.readEmailConfigModel.userName &&
          this.readEmailConfigModel.password
        ) {
          await storeService.saveReadEmailConfigProvider(
            Number(this.storeId),
            this.readEmailConfigModel
          );
          this.showAlert(true, this.$t('stores.readEmail.alertSaved'));
          this.$router.push({
            name: 'admin.stores.edit',
            params: {
              tenantId: this.tenantId.toString(),
              enterpriseId: this.enterpriseId.toString(),
              storeId: this.storeId.toString(),
              tab: 'ReadEmailConfig'
            },
          });
        } else {
          this.showAlert(
            false,
            this.$t('stores.readEmail.alertFillRequiredFields')
          );
        }
      } finally {
        this.requestProgress = false;
        this.$emit('update:progress', this.requestProgress);
      }
    }
  }
  public async verifyConnection(): Promise<void> {
    try {
      this.verifyConnectionrequestProgress = true;
      this.$emit('update:progress', this.verifyConnectionrequestProgress);
      if (
        this.readEmailConfigModel &&
        this.readEmailConfigModel.emailType &&
        this.readEmailConfigModel.hostProtocol &&
        this.readEmailConfigModel.host &&
        this.readEmailConfigModel.port &&
        this.readEmailConfigModel.userName &&
        this.readEmailConfigModel.password
      ) {
        const response = await storeService.VerifyEmailConnection(
          this.readEmailConfigModel
        );
        response.status == true
          ? this.showAlert(true, this.$t('stores.readEmail.verifyAlertSaved'))
          : this.showAlert(
              false,
              this.$t('stores.readEmail.verifyAlertNotSaved')
            );
        this.verifyConnectionrequestProgress = false;
      } else {
        this.verifyConnectionrequestProgress = false;
        this.showAlert(
          false,
          this.$t('stores.readEmail.alertFillRequiredFields')
        );
      }
    } finally {
      this.verifyConnectionrequestProgress = false;
      this.requestProgress = false;
      this.$emit('update:progress', this.requestProgress);
    }
  }

  public updateEmailType(emailTypeId: string): void {
    if (emailTypeId == 'Gmail') {
      this.readEmailConfigModel.host = 'imap.gmail.com';
      this.readEmailConfigModel.port = 993;
      this.readEmailConfigModel.ssl = true;
      this.readEmailConfigModel.hostProtocol = 'IMAP';
      this.passwordLink =
        'https://support.google.com/accounts/answer/185833?hl=en';
    } else if (emailTypeId == 'Microsoft') {
      this.readEmailConfigModel.host = 'imap.gmail.com';
      this.readEmailConfigModel.port = 993;
      this.readEmailConfigModel.ssl = true;
      this.readEmailConfigModel.hostProtocol = 'IMAP';
      this.passwordLink =
        'https://support.microsoft.com/en-us/account-billing/using-app-passwords-with-apps-that-don-t-support-two-step-verification-5896ed9b-4263-e681-128a-a6f2979a7944';
    } else if (emailTypeId == 'other') {
      this.readEmailConfigModel = {
        storeId: this.storeModel.id,
        storeName: this.storeViewModel.storeJson.name,
        host: '',
        port: null,
        ssl: false,
        userName: '',
        password: '',
        emailType: 'other',
        isEmailSyncEnabled: true,
      };
      this.passwordLink = '';
    }
    this.setReadEmailFields();
  }

  public updateHostProtocolType(hostProtocolType: string): void {
    if (
      this.readEmailConfigModel.emailType == 'Gmail' &&
      hostProtocolType == 'IMAP'
    ) {
      this.readEmailConfigModel.host = 'imap.gmail.com';
      this.readEmailConfigModel.port = 993;
      this.readEmailConfigModel.ssl = true;
    } else if (
      this.readEmailConfigModel.emailType == 'Gmail' &&
      hostProtocolType == 'POP3'
    ) {
      this.readEmailConfigModel.host = 'pop.gmail.com';
      this.readEmailConfigModel.port = 995;
      this.readEmailConfigModel.ssl = true;
    } else if (
      this.readEmailConfigModel.emailType == 'Microsoft' &&
      hostProtocolType == 'IMAP'
    ) {
      this.readEmailConfigModel.host = 'outlook.office365.com';
      this.readEmailConfigModel.port = 993;
      this.readEmailConfigModel.ssl = true;
    } else if (
      this.readEmailConfigModel.emailType == 'Microsoft' &&
      hostProtocolType == 'POP3'
    ) {
      this.readEmailConfigModel.host = 'outlook.office365.com';
      this.readEmailConfigModel.port = 995;
      this.readEmailConfigModel.ssl = true;
    }
  }
}
